export default __webpack_public_path__ + "static/media/Tier2.2d6a063e.png";